import { setLocale } from '../../helper/i18n/index'

export default {
  render(h) {
    return (
      <div class="sp-header">
        {this.$slots.logo}
        <span class="sp-header-col sp-cursor-pointer">
          <el-dropdown trigger="click" on-command={this.onUserDropdownCommand}>
            <div><icon name="user-circle"></icon></div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item disabled>{this.user.email}</el-dropdown-item>
              <el-dropdown-item divided command="logout">{this.$i18n('Logout')}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </span>
        <span class="sp-header-col sp-cursor-pointer">
          <el-dropdown trigger="click" on-command={this.onSetLocale}>
            <div><icon name="language"></icon></div>
            <el-dropdown-menu slot="dropdown">
              {
                Object.entries(this.locales).map(([locale, { _name }]) => (
                  <el-dropdown-item command={locale}>{_name}</el-dropdown-item>
                ))
              }
            </el-dropdown-menu>
          </el-dropdown>
        </span>
        <span class="sp-header-col">{this.$slots.default}</span>
      </div>
    )
  },
  props: ['user', 'locales', 'logout'],
  methods: {
    onUserDropdownCommand(command) {
      if (command === 'logout') {
        this.logout()
      }
    },
    onSetLocale(locale) {
      setLocale(locale)
    }
  }
}



// WEBPACK FOOTER //
// ./packages/components/Header/index.js